import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgFacebookLogoSquare: React.FunctionComponent<
  SVGProps<SVGSVGElement>
> = props => (
  <svg viewBox="0 0 32 32" {...props}>
    <path d="M22 32V20h4l1-5h-5v-2c0-2 1-3 3-3h2V5h-4c-3.68 0-6 2.88-6 7v3h-4v5h4v12H2a2 2 0 0 1-2-2V2C0 .9.9 0 2 0h28a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2h-8z" />
  </svg>
);
/* eslint-enable max-len */

export default SvgFacebookLogoSquare;
